import { render, staticRenderFns } from "./PaymentFormAuthorize.vue?vue&type=template&id=4ee701ba"
import script from "./PaymentFormAuthorize.vue?vue&type=script&lang=js"
export * from "./PaymentFormAuthorize.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports